import axios from 'axios'
import { toast } from 'react-toastify';
import { memoizedRefreshToken } from './refreshToken';
import moment from 'moment';


const IDENTITY_SERVER_URL = 'https://beta-identity.sekaans.com'
// const IDENTITY_SERVER_URL = 'https://identity.sekaans.com'
const SERVER_URL = 'https://beta-api.sekaans.com'
// const SERVER_URL = 'https://api.sekaans.com'


// interceptors
axios.interceptors.request.use(

  async (config) => {
    const token = JSON.parse(localStorage.getItem('user'))

    if (token) config.headers["Authorization"] = 'Bearer ' + token.a

    return config
  },

  (error) => {
    return Promise.reject(error)
  }
)



axios.interceptors.response.use(

  response => {
    return response
  },

  async (error) => {
    const config = error?.config;

    if (error?.response?.status === 401 && !config?.sent) {
      config.sent = true;

      const result = await memoizedRefreshToken();
      if (result) {
        config.headers = {
          ...config.headers,
          authorization: `Bearer ${result}`,
        };
        return axios(config);
      }

      return Promise.reject(error);
    }

    const data = error?.response?.data

    if (data) {
      if (data.detail) {
        toast.error(data.detail)
      } else if (data.title) {
        toast.error(data.title)
      } else if (typeof data === 'string') {
        toast.error(data)
      } else if (Array.isArray(data) && data.length) {
        data.forEach((item) => {
          if (typeof item === 'string') toast.error(item)
          else if (item?.message) toast.error(item.message)
        })
      }
    } else if (error?.message) {
      toast.error(
        error.message === 'Network Error'
          ? 'خطا در برقراری ارتباط با سرور'
          : error.message
      )
    }

    return Promise.reject(error);
  }

)
// interceptors





//Basic


// export const Get_provinces = () => {
//   const url = SERVER_URL + '/v1/web/basic/provinces'
//   return url
// }
// export const Get_cities = provincesID => {
//   const url = SERVER_URL + '/v1/web/basic/province/' + provincesID + '/cities'
//   return url
// }

export const Get_Setting = SERVER_URL + '/v1/web/basic/setting'
export const Set_Setting = SERVER_URL + '/v1/web/basic/setting/upsert'
export const Withdrawal = SERVER_URL + '/v1/web/Payment/Withdrawal/new'
export const Payment_new = SERVER_URL + '/v1/web/Payment/New'
export const Payment_Retry = SERVER_URL + '/v1/web/Payment/Retry'
export const Logout = IDENTITY_SERVER_URL + '/v1/account/logout'

export const Get_operators = SERVER_URL + '/v1/web/basic/operator/all'
export const Get_operatorsSetting = SERVER_URL + '/v1/web/basic/setting/TrafficPrice/all'
export const post_TrafficPrice = SERVER_URL + '/v1/web/basic/setting/TrafficPrice'



//Payment

export const WithdrawalType = SERVER_URL + '/v1/web/Payment/Withdrawal/WithdrawalType/all'
export const PaymentSettlement = SERVER_URL + '/v1/web/Payment/Settlement/Summary'
export const GatewayList = SERVER_URL + '/v1/web/Payment/Gateway/latest'

export const PayWithdrawal = payID => {
  const url = SERVER_URL + '/v1/web/Payment/Withdrawal/' + payID
  return url
}
export const GET_lastes_Withdrawals = page => {
  const url = SERVER_URL + '/v1/web/Payment/Withdrawal/latest/' + page
  return url
}
export const PaymentLastes = page => {
  const url = SERVER_URL + '/v1/web/Payment/Settlement/latest/' + page
  return url
}
export const PaymentVerify = paymentId => {
  const url = SERVER_URL + '/v1/web/Payment/Inquiry/' + paymentId
  return url
}
export const Get_Subject_Payment = (ID, BranchId, PublisherId) => {
  const url = `${SERVER_URL}/v1/web/Subject/${ID}/PaymentPage?SubjectBranchId=${BranchId}&PublisherId=${PublisherId}`
  return url
}



//Subject


export const Get_Subject = (page = 1, pageSize = 0, catID, haveParams = null, parengID) => {
  const pageNum = page ? page : 1
  const params = new URLSearchParams()
  params.set('pageSize', String(pageSize))

  // مسیرهای /type/games و /type/videos اسلاگ متنی‌اند، نه شناسه دسته.
  // API برای نوع موضوع فیلد Type می‌خواهد (0=بازی، 1=ویدئو).
  const routeKey = parengID || catID
  if (routeKey === 'games') {
    params.set('Type', '0')
  } else if (routeKey === 'videos') {
    params.set('Type', '1')
  } else if (routeKey && routeKey !== 'all') {
    params.set('ParentCategoryId', String(routeKey))
  }

  if (haveParams) {
    const raw = String(haveParams).replace(/^\?/, '')
    if (raw) {
      const extra = new URLSearchParams(raw)
      extra.forEach((value, key) => {
        if (value !== '' && value != null) params.set(key, value)
      })
    }
  }

  return SERVER_URL + '/v1/web/Subject/latest/' + pageNum + '?' + params.toString()
}

export const Get_Subject_ID = SERVER_URL + '/v1/web/Subject/'
export const New_Subject = SERVER_URL + '/v1/web/Subject/new'

export const Get_Platforms = (page = 1, pageSize = 50) => {
  return SERVER_URL + `/v1/web/Subject/platform/latest?page=${page}&pageSize=${pageSize}`
}

export const Get_Features = SERVER_URL + '/v1/web/Subject/features/latest'

export const METADATA_TYPES = {
  DEVELOPER: 0,
  PUBLISHER: 1,
  COLLECTION: 2,
  COUNTRY: 3,
}

export const HARDWARE_TYPES = {
  CPU: 0,
  GPU: 1,
}

export const Get_OperatingSystems = SERVER_URL + '/v1/web/Subject/operatingSystem/types/latest'

export const Get_GamingHardware = (type, search = '', page = 1, pageSize = 10) => {
  const searchQuery = search ? `&search=${encodeURIComponent(search)}` : ''
  return SERVER_URL + `/v1/web/basic/gaming-hardware/latest?type=${type}${searchQuery}&page=${page}&pageSize=${pageSize}`
}

export const Get_Metadata = (type, search = '', page = 1, pageSize = 10) => {
  const searchQuery = search ? `&search=${encodeURIComponent(search)}` : ''
  return SERVER_URL + `/v1/web/Subject/metadata/latest?type=${type}${searchQuery}&page=${page}&pageSize=${pageSize}`
}



export const get_Download_links = (post_id, user_id) => {
  const url = SERVER_URL + `/v1/web/Subject/${post_id}/branch/publisher/${user_id}`
  return url
}

//SubjectCategory

///v1/{platform}/SubjectCategory/latest/{page}
export const Get_SubjectCategory = async (page, pageSize = 0) => {
  const url = SERVER_URL + '/v1/web/Category/latest/' + page + `?pageSize=${pageSize}`
  const res = await axios.get(url)
  return res
}

export const Get_SubjectCategory_ID = (id) => {
  const url = SERVER_URL + '/v1/web/Category/' + id
  // const res = await axios.get(url)
  return url
}

export const Get_SubjectCategory_ID_Children = (id) => {
  const url = SERVER_URL + '/v1/web/Category/' + id + '/children'
  return url
}


export const New_SubjectCategory = SERVER_URL + '/v1/web/Category/new'
export const CategoryParents = SERVER_URL + '/v1/web/Category/latest/1?onlyRoot=true'

//SubjectProperty





// ///v1/{platform}/Subject/Property/latest/{page}
// export const Get_Property = async page => {
//   const url = SERVER_URL + '/v1/web/Subject/Property/latest/' + page
//   const res = await axios.get(url)
//   return res
// }
// export const Get_Property_ID = async id => {
//   const url = SERVER_URL + '/v1/web/Subject/Property/' + id
//   const res = await axios.get(url)
//   return res
// }





/// media


export const mediaUpload = SERVER_URL + '/v1/1/upload/media'

export const get_media = (id) => {
  const url = SERVER_URL + '/v1/web/media/' + id
  return url
}






//// user

export const getRoles = SERVER_URL + '/v1/10/User/Role/latest'
export const newUser = SERVER_URL + '/v1/web/User/new'
export const userCount = SERVER_URL + '/v1/web/User/Statistics'
export const userTraffic = (type = null) => {
  const query = type == null ? '' : `?Type=${type}`
  return SERVER_URL + '/v1/web/Report/User/Traffic' + query
}
export const userCredit = SERVER_URL + '/v1/web/User/Credit'
export const put_user = SERVER_URL + '/v1/web/User'
export const totalTrafficAdmin = (type = null) => {
  const query = type == null ? '' : `?Type=${type}`
  return SERVER_URL + '/v1/web/Report/Publisher/Traffic' + query
}
// export const userIncome = SERVER_URL + '/v1/web/Report/User/Income/'

// export const userList = SERVER_URL + '/v1/web/User/Producer/latest/1'

export const SoldProducts = (SubjectId, type = null) => {
  const params = new URLSearchParams({
    SubjectId: SubjectId ? String(SubjectId) : '',
  })
  if (type != null) params.set('Type', String(type))
  const url = SERVER_URL + `/v1/web/Report/Subjects/Sold?${params.toString()}`
  return url
}

export const userTrafficSingle = (postId, type = null) => {
  const params = new URLSearchParams({ SubjectId: String(postId) })
  if (type != null) params.set('Type', String(type))
  const url = SERVER_URL + `/v1/web/Report/User/Traffic?${params.toString()}`
  return url
}

export const userTrafficEdit = (userID) => {
  const url = SERVER_URL + `/v1/web/User/${userID}/Traffic`
  return url
}

export const userIncome = (DateRange, type = 0) => {
  const url = SERVER_URL + '/v1/web/Report/User/Income?DateRange=' + DateRange + '&type=' + type
  return url
}

export const userTrafficEdit_put = (userId) => {
  const url = SERVER_URL + '/v1/web/User/' + userId + '/Traffic'
  return url
}

export const get_users = (keyword = '', pageNum = 1) => {
  let newKeyword = keyword.replace('?', '&')
  const url = SERVER_URL + '/v1/web/User/latest/' + pageNum + '?pageSize=10' + newKeyword
  return url
}

export const get_user = (userid = '') => {
  const url = SERVER_URL + '/v1/web/User/' + userid
  return url
}

export const producer_autosuggest = (keyword = '') => {
  const url = SERVER_URL + '/v1/web/User/Producer/autosuggest?keyword=' + keyword
  return url
}
export const publisher_autosuggest = (keyword = '') => {
  const url = SERVER_URL + '/v1/web/User/Publisher/autosuggest?keyword=' + keyword
  return url
}

export const types_subject = () => {
  const url = SERVER_URL + '/v1/web/Subject/DownloadLink/types/latest'
  return url
}

export const sell_types_subject = () => {
  const url = SERVER_URL + '/v1/web/Subject/branch/types/latest'
  return url
}
export const subject_price_changer = (post_id) => {
  const url = SERVER_URL + '/v1/web/Subject/branch/' + post_id + '/CustomPublisherShare'
  return url
}

export const get_activation_codes = (post_id) => {
  const url = `${SERVER_URL}/v1/web/Subject/branch/${post_id}/activationCodeFileNames`
  return url
}
export const delete_activation_code = (mediaId) => {
  const url = `${SERVER_URL}/v1/web/Subject/branch/activationCode/${mediaId}`
  return url
}
//Purchased

export const Get_Purchased = (page = 1) => {
  let pageNum = page ? page : 1
  const url = SERVER_URL + '/v1/web/Subject/Bought/latest/' + pageNum
  return url
}

export const Get_Single_Purchased = (id) => {
  const url = SERVER_URL + '/v1/web/Subject/Bought/' + id
  return url
}

export const Get_orders = (page = 1, pageSize = 20, query = '') => {
  const url = SERVER_URL + '/v1/web/Subject/Purchases/latest/' + page + query
  return url
}

//reports

export const CATEGORY_PC = 12
export const CATEGORY_PS4 = 19
export const CATEGORY_XBOX = 20

export const Get_Popular_Subjects = (
  page = 1,
  {
    pageSize = 8,
    sortType = 0,
    dateType = 0,
    type = 0,
    primarySubjectCategoryId = CATEGORY_PC,
  } = {}
) => {
  const params = new URLSearchParams()
  params.set('pageSize', String(pageSize))

  if (sortType !== null && sortType !== undefined && sortType !== '') {
    params.set('SortType', String(sortType))
  }
  if (dateType !== null && dateType !== undefined && dateType !== '') {
    params.set('DateType', String(dateType))
  }
  // Type omitted entirely for «مجموع» — do not send empty Type
  if (type !== null && type !== undefined && type !== '') {
    params.set('Type', String(type))
  }
  if (
    primarySubjectCategoryId !== null &&
    primarySubjectCategoryId !== undefined &&
    primarySubjectCategoryId !== ''
  ) {
    params.set('PrimarySubjectCategoryId', String(primarySubjectCategoryId))
  }

  return (
    SERVER_URL +
    '/v1/web/Report/Subject/Traffic/latest/' +
    page +
    '?' +
    params.toString()
  )
}

export const get_date_dropdown = () => {
  const url = SERVER_URL + '/v1/web/Report/Subject/Traffic/date/types/latest/'
  return url
}

export const get_sort_dropdown = () => {
  const url = SERVER_URL + '/v1/web/Report/Subject/Traffic/sort/types/latest/'
  return url
}

export const get_reports = (page = 1, pageSize = 20, query = '', toExcel = false) => {
  if (query) {
    return SERVER_URL + '/v1/web/Report/Subject/Traffic/latest/' + page + query + `&toExcel=${toExcel}`
  } else {
    return SERVER_URL + '/v1/web/Report/Subject/Traffic/latest/' + page + `?dateType=1&toExcel=${toExcel}`
  }
}



export const get_users_reports_traffic = (query = '', all = true) => {
  if (all) {
    return SERVER_URL + '/v1/web/Subject/User/DownloadAndSale?all=true&' + query
  } else {
    return SERVER_URL + '/v1/web/Subject/User/DownloadAndSale?' + query
  }
}


export const get_property_reports_traffic = (query = '', type = 0, dataSelected) => {

  const filterUserId = dataSelected?.filterUserId?.value ?? '',
    productionYear = type === 0 ? '' : dataSelected?.publishDate?.value ?? '',
    age = type === 1 ? "" : dataSelected?.ages?.value ?? ''

  return `${SERVER_URL}/v1/web/Subject/Property/DownloadAndSale?type=${type}&filterUserId=${filterUserId}&productionYear=${productionYear}&age=${age}&${query}`
}


export const get_chart_reports_traffic = SERVER_URL + '/v1/web/Report/Subject/Traffic'

export const downloadXLSFile = async (requestURL) => {
  moment.locale('en-US')
  const fileName = 'report_' + moment().format('YYYY-MM-DD_h-mm-ss')

  let axiosConfig = {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'blob',
    }
  }

  try {
    const response = await axios.get(requestURL, axiosConfig)
    const outputFilename = `${fileName}.xls`

    // If you want to download file automatically using link attribute.
    const url = URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', outputFilename)
    document.body.appendChild(link)
    link.click()

  } catch (error) {
    throw Error(error)
  }
}